<template>
  <div
    class="condition"
    style="padding: 0; margin-left: 0; border-radius: 0; border: none"
  >
    <div class="contents" style="display: flex; margin-top: 10px">
      <div v-if="contents[patternContentIndex].groupContents" style="width: 100%">
        <!-- 20230704 padding: 20px 삭제 -->
        {{ contents[patternContentIndex].groupContents[0].subContents[1] }}
        <div
          v-for="(groupContent, groupIndex) in contents[patternContentIndex]
            ?.groupContents"
          :key="groupContent.code"
          class="groupContent"
        >
          <div v-if="!groupContent.customer" class="lock">
            <img src="@/assets/img/lock60.png" />
            <span>{{ $t("message.subscription_option1") }} {{ $t("message.subscription_option2") }}</span>
          </div>
          <div class="group-content-header">
            {{ getDisplayName(groupContent) }}
          </div>
          <div class="sub-contents-container">
            <span v-if="groupContent.list" class="sub-content-items">
              <template
                v-for="(data, index) in groupContent.list[0].list
                  .filter((item) => {
                    if (parentMenuCode === constants.CONSTANT_MENU_CL_Diagnosis_CODE) {
                      return (
                        item.name === ATC_GROUP ||
                        item.name === Molecule_GROUP ||
                        (!ATC_ITEM_NAMES.includes(item.name) &&
                          !Molecule_ITEM_NAMES.includes(item.name))
                      );
                    } else {
                      return true;
                    }
                  })"
                :key="data.id"
              >
                <div v-if="index === 6" style="flex: 0 0 100%"></div>
                <div
                  class="sub-content-item"
                  :class="{
                    'active-item': isActive(data, groupIndex),
                    'not-active-item': state.disabledControl.has(groupIndex)
                                    || (Object.keys(state.disabledItemControl).includes(String(groupIndex)) && state.disabledItemControl[groupIndex].includes(index)),
                    switching:
                      this.$i18n.locale === 'ko' &&
                      parentMenuCode === constants.CONSTANT_MENU_SWITCHING_CODE &&
                      groupIndex === 0,
                    switchingEn:
                      this.$i18n.locale === 'en' &&
                      parentMenuCode === constants.CONSTANT_MENU_SWITCHING_CODE &&
                      groupIndex === 0,
                  }"
                  @click.stop="
                    parentMenuCode === constants.CONSTANT_MENU_CL_Diagnosis_CODE &&
                    [ATC_GROUP, Molecule_GROUP].includes(data.name)
                      ? dropdownSelection.selectedType === null &&
                        dropdownSelection.visible &&
                        dropdownSelection.index === groupIndex
                        ? toggleDropdown(groupIndex, data.name)
                        : (selectDropdownDetail(
                            data.name,
                            data,
                            groupContent,
                            groupIndex,
                            data.name
                          ),
                          toggleDropdown(groupIndex, data.name))
                      : !state.disabledControl.has(groupIndex) && !(Object.keys(state.disabledItemControl).includes(String(groupIndex)) && state.disabledItemControl[groupIndex].includes(index))
                      ? onClick(
                          data,
                          groupContent?.code,
                          groupContent?.subContents[0]?.code,
                          groupIndex
                        )
                      : false
                  "
                >
                  {{
                    parentMenuCode === constants.CONSTANT_MENU_CL_Diagnosis_CODE &&
                    [ATC_GROUP, Molecule_GROUP].includes(data.name) &&
                    dropdownSelection.selectedIndex === groupIndex &&
                    dropdownSelection.baseName === data.name &&
                    dropdownSelection.selectedType &&
                    state.activeItem[groupIndex] &&
                    ((data.name === ATC_GROUP &&
                      ATC_ITEM_NAMES.includes(state.activeItem[groupIndex].name)) ||
                      (data.name === Molecule_GROUP &&
                        Molecule_ITEM_NAMES.includes(state.activeItem[groupIndex].name)))
                      ? getDisplayName(state.activeItem[groupIndex]) ||
                        dropdownSelection.selectedType
                      : getDisplayName(data)
                  }}

                  <template
                    v-if="
                      parentMenuCode === constants.CONSTANT_MENU_CL_Diagnosis_CODE &&
                      (data.name === ATC_GROUP || data.name === Molecule_GROUP)
                    "
                  >
                    <button class="dropdown-button">
                      <span class="material-symbols-outlined">expand_more</span>
                      <!-- v -->
                    </button>

                    <div
                      v-if="
                        dropdownSelection.visible &&
                        dropdownSelection.index === groupIndex &&
                        dropdownSelection.baseName === data.name
                      "
                      class="atcMolecule-dropdown"
                    >
                      <div
                        v-for="option in groupContent.list[0].list
                          .filter((item) =>
                            (data.name === ATC_GROUP
                              ? ATC_ITEM_NAMES
                              : Molecule_ITEM_NAMES
                            ).includes(item.name)
                          )
                          .sort((a, b) => a.id - b.id)"
                        :key="option.id"
                        @click.stop="
                          selectDropdownDetail(
                            option.name,
                            option,
                            groupContent,
                            groupIndex
                          )
                        "
                        class="atcMolecule-dropdown-item"
                      >
                        {{ getDisplayName(option) }}
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </span>
          </div>
        </div>
        <div
          v-if="
            constants.CONSTANT_MENU_COMBINATION_THERAPY_NEW_CODE.includes(parentMenuCode)
          "
          style="display: flex"
        >
          <div>
            <input
              type="checkbox"
              id="viewTotal"
              v-model="checkedViewTotal"
              @change="checkViewTotal($event)"
            />
            <label for="viewTotal">{{ $t("label.view_all") }}</label>
          </div>
        </div>
      </div>

      <div v-else class="groupContent">
        <div style="width: 100%">
          <!-- 20230704 padding: 20px 삭제 -->
          <!-- 20230612 스타일 추가 { -->
          <div class="group-content-header">{{ $t("label.measurement") }}</div>

          <div class="sub-contents-container">
            <span class="sub-content-items">
              <div
                v-for="(item, index) in showContent?.list[0]?.list"
                :key="(item, index)"
                class="sub-content-item"
                :class="{
                  'active-item': isActive(item, 0),
                }"
                @click.stop="
                  onClick(item, showContent?.code, showContent?.subContents[0]?.code, 0)
                "
              >
                {{
                  $i18n.locale == "en"
                    ? item.englishName != ""
                      ? item.englishName
                      : item.name + "(en)"
                    : item.name
                }}
              </div>
            </span>
          </div>
        </div>
      </div>
    </div>

    <p
      v-if="constants.CONSTANT_MENU_COMBINATION_THERAPY_NEW_CODE.includes(parentMenuCode)"
      class="content-notice"
      style="cursor: pointer"
      @click.stop="openPopupImage()"
    >
      <span
        class="material-symbols-outlined"
        style="font-size: 28px; font-weight: 300; margin-right: 5px"
      >
        info
      </span>
      <span>{{ $t("message.combination_new_tooltip") }}</span>
    </p>

    <div v-if="parentMenuCode === '000'" class="comparison">
      <h2>
        <span class="material-symbols-outlined">info</span>
        {{ $t("label.measurement_info_title") }}
      </h2>
      <div class="comparison-container">
        <div class="comparison-item">
          <p>{{ $t("label.measurement_info_subtitle1") }}</p>
          <ul>
            <li>{{ $t("label.measurement_info_period") }}</li>
            <li>{{ $t("label.measurement_info_measurement") }}</li>
            <li>{{ $t("label.measurement_info_output_period") }}</li>
          </ul>
        </div>
        <div class="comparison-item">
          <p>{{ $t("label.measurement_info_subtitle2") }}</p>
          <ul>
            <li>{{ $t("label.measurement_info_period") }}</li>
            <li>{{ $t("label.measurement_info_measurement") }}</li>
            <li>{{ $t("label.measurement_info_output_period") }}</li>
          </ul>
        </div>
      </div>
    </div>

    <p
      v-if="parentMenuCode === constants.CONSTANT_MENU_DIAGNOSIS_1_CODE"
      class="content-notice"
      style="align-items: flex-start;"
    >
      <span
        class="material-symbols-outlined"
        style="font-size: 28px; font-weight: 300; margin-right: 5px"
      >
        info
      </span>
      <span style="white-space: pre-wrap">{{ $t("label.only_disease") }}</span>
    </p>
    <p
      v-if="parentMenuCode === constants.CONSTANT_MENU_CL_Diagnosis_CODE"
      class="content-notice notice-small"
    >
      <span
        class="material-symbols-outlined"
        style="font-size: 20px; font-weight: 300; margin-right: 5px"
      >
        info
      </span>
      <span>{{ $t("label.cl_Diagnosis_result_info") }}</span>
    </p>
    <p
      v-if="[constants.CONSTANT_MENU_HANDLING_CODE, constants.CONSTANT_MENU_SWITCHING_CODE].includes(parentMenuCode)"
      class="content-notice notice-small"
      style="align-items: flex-start;"
    >
      <span
        class="material-symbols-outlined"
        style="font-size: 20px; font-weight: 300; margin-right: 5px; margin-top: 2px;"
      >
        info
      </span>
      <span style="white-space: pre-wrap">{{ $t("label.HCD_Switching_Handling_result_info") }}</span>
    </p>
  </div>
</template>

<script>
import constants from "@/data/constants.js";
import { defineComponent, ref, reactive, onMounted, watch } from "vue";
import { storeToRefs } from "pinia";
import { useI18n } from "vue-i18n";
import { useContentsStore } from "@/store/contents";

export default defineComponent({
  name: "MeasurementCondition",
  props: ["parentMenu", "parentMenuCode", "selectedComponentIndex", "customFunction"],

  components: {},
  setup(props) {
    const { t, locale } = useI18n();

    const contentsStore = useContentsStore();
    const { showContent, contents, patternContentIndex, patternSelected } = storeToRefs(
      contentsStore
    );

    //제품선택-드롭박스그룹
    const Molecule_GROUP = "성분";
    const ATC_GROUP = "ATC";
    //제품선택-드롭박스항목
    const Molecule_ITEM_NAMES = [
      "성분명",
      "성분명(용량)",
      "성분코드",
      "성분명(용량)+코드",
    ];
    const ATC_ITEM_NAMES = ["ATC명", "ATC코드", "ATC명+코드"];

    const dropdownSelection = reactive({
      visible: false,
      selectedType: null,
      index: null,
      baseName: null, // 'ATC' 또는 '성분'
    });

    const toggleDropdown = (index, baseName) => {
      const isSame =
        dropdownSelection.visible &&
        dropdownSelection.index === index &&
        dropdownSelection.baseName === baseName;

      if (isSame) {
        dropdownSelection.visible = false;
        dropdownSelection.index = null;
        dropdownSelection.baseName = null;
      } else {
        dropdownSelection.visible = true;
        dropdownSelection.index = index;
        dropdownSelection.baseName = baseName;
      }
    };

    const selectDropdownDetail = (
      optionName,
      data,
      groupContent,
      groupIndex,
      baseName
    ) => {
      const displayName =
        locale.value === "en" && data.englishName ? data.englishName : data.name;

      const isBaseClicked = optionName === baseName;

      if (isBaseClicked) {
        if (dropdownSelection.baseName === baseName) {
          dropdownSelection.selectedType = null;
          dropdownSelection.selectedIndex = null;
          state.activeItem[groupIndex] = null;

          if (patternSelected.value[props.selectedComponentIndex]) {
            patternSelected.value[props.selectedComponentIndex][groupIndex] = {
              code: groupContent.code,
              list: [],
            };
          }
        }
      } else {
        dropdownSelection.selectedType = optionName;
        dropdownSelection.selectedIndex = groupIndex;

        patternSelected.value[props.selectedComponentIndex][groupIndex] = {
          code: groupContent.code,
          list: [
            {
              ...data,
              type: 0,
              code: groupContent?.subContents[0]?.code,
              displayName,
            },
          ],
        };

        state.activeItem[groupIndex] = { ...data, displayName };
      }

      dropdownSelection.visible = false;
      dropdownSelection.index = null;
    };

    const checkedViewTotal = ref(
      patternSelected.value?.[4]
        ? patternSelected.value[4][3]
          ? patternSelected.value[4][3].isTotal
          : false
        : false
    );

    const checkViewTotal = () => {
      if (!patternSelected.value[4]) patternSelected.value[4] = [];
      if (!patternSelected.value[4][3]) {
        patternSelected.value[4][3] = {
          list: [],
        };
      }

      patternSelected.value[4][3].isTotal = checkedViewTotal.value;
    };

    const state = reactive({
      disabledControl: new Set([]),
      disabledItemControl: {},
      activeItem: {}, // 활성화된 버튼 추적 위해
    });

    const setupSub = () => {
      const content = contents.value[patternContentIndex.value];
      if (!content || !Array.isArray(content.groupContents)) return;

      if (!patternSelected.value[patternContentIndex.value]) {
        patternSelected.value[patternContentIndex.value] = [];
      }

      if (content?.groupContents) {
        content.groupContents.forEach((c) => {
          contentsStore.onClickPatternContentItem(c);
        });

        if (content.groupType === 1) {
          content.groupContents.forEach((item, groupIndex) => {
            const selectedGroup =
              patternSelected.value?.[patternContentIndex.value]?.[groupIndex];

            if (selectedGroup?.list?.length > 0) {
              const selItem = selectedGroup.list[0];
              const { id, name, englishName, displayName } = selItem;
              state.activeItem[groupIndex] = { id, name, englishName, displayName };

              const updatedDisplayName =
                locale.value === "en" && selItem.englishName
                  ? selItem.englishName
                  : selItem.name;

              if (ATC_ITEM_NAMES.includes(String(name))) {
                dropdownSelection.selectedIndex = groupIndex;
                dropdownSelection.baseName = ATC_GROUP;
                dropdownSelection.selectedType = updatedDisplayName;
              } else if (Molecule_ITEM_NAMES.includes(String(name))) {
                dropdownSelection.selectedIndex = groupIndex;
                dropdownSelection.baseName = Molecule_GROUP;
                dropdownSelection.selectedType = updatedDisplayName;
              }
            }
          });
        }
      } else {
        contents.value.forEach((content, idx) => {
          const selected = patternSelected.value?.[idx]?.[0];
          if (selected?.list?.length > 0) {
            const { id, name, englishName, displayName } = selected.list[0];
            state.activeItem[0] = { id, name, englishName, displayName };
          }
        });
      }

      if (props.parentMenuCode === constants.CONSTANT_MENU_DIAGNOSIS_1_CODE) {
        handleDiagnosisMenu();
      }

      if (props.parentMenuCode === constants.CONSTANT_MENU_SWITCHING_CODE) {
        handleSwitchingMenu();
      }

      if ([constants.CONSTANT_MENU_SWITCHING_CODE, constants.CONSTANT_MENU_HANDLING_CODE].includes(props.parentMenuCode)) {
        handleSwitchingHandingMenu();
      }
    };

    onMounted(() => {
      // console.log("🟢 컴포넌트 마운트됨");
      setupSub();
    });

    watch([patternContentIndex], () => {
      setupSub(); // 상태 복원
    });

    const handleDiagnosisMenu = () => {
      console.log('patternSelected.value[3]', patternSelected.value[3])
      if (!patternSelected.value[0]?.[0]?.code) {
        state.disabledControl.add(1);
        state.disabledControl.add(2);
        if (patternSelected.value[3]) {
          const temp = [];
          temp[0] = patternSelected.value[3][0];
          patternSelected.value[3] = temp;
        }
        return;
      }

      const isDiseasePattern = patternSelected.value[0]?.[0]?.code === constants.CONSTANT_DISEASE_PATTERN_CODE;

      //질병일 경우
      if (isDiseasePattern) {
        state.disabledControl.delete(1);
        state.disabledControl.add(2);
        if (patternSelected.value[3].length > 1) {
          const temp = [];
          temp[0] = patternSelected.value[3][0];
          if (patternSelected.value[3][1]) temp[1] = patternSelected.value[3][1];
          patternSelected.value[3] = temp;
        }
      } else {
        //질병이 아닐 경우
        state.disabledControl.add(1);
        state.disabledControl.delete(2);
        if (patternSelected.value[3].length > 1) {
          const temp = [];
          temp[0] = patternSelected.value[3][0];
          if (patternSelected.value[3][2]) temp[2] = patternSelected.value[3][2];
          patternSelected.value[3] = temp;
        }
      }
    };

    const handleSwitchingMenu = () => {
      const idx = patternSelected.value.length === 5 ? 3 : 2;
      const selectedCode = patternSelected.value[idx]?.[0]?.list?.[0]?.code;

      const isQuarter =
        selectedCode === constants.CONSTANT_SWITCHING_QUARTER_PERIOD_CODES;
      const isMonth = selectedCode === constants.CONSTANT_SWITCHING_MONTH_PERIOD_CODES;

      isQuarter ? state.disabledControl.delete(1) : state.disabledControl.add(1);
      isMonth ? state.disabledControl.delete(0) : state.disabledControl.add(0);
    };

    const handleSwitchingHandingMenu = () => {
        const rcpSelected = patternSelected.value[2];
        const lastSelected = patternSelected.value[patternSelected.value.length - 1];
        if (rcpSelected[0].list[0].englishName !== 'All') {
          const Llist = rcpSelected[0].list.filter(item => item.code === constants.CONSTANT_REGIONS_LARGE_CODE);
          const sList = rcpSelected[0].list.filter(item => item.code === constants.CONSTANT_REGIONS_SMALL_CODE);
          
          if (Llist.length === 1 || sList.length > 0) {
            state.disabledItemControl[lastSelected.length - 3] = [1];
          }

          if (Llist.length === 0 && sList.length === 1) {
            state.disabledItemControl[lastSelected.length - 3] = [1, 2];
          }
        }
        if (rcpSelected[1].list[0].englishName !== 'All' && rcpSelected[1].list.length === 1) {
          state.disabledItemControl[lastSelected.length - 2] = [1];
        }
        if (rcpSelected[2].list[0].englishName !== 'All') {
          const subSpList = rcpSelected[2].list.filter(item => item.code === constants.CONSTANT_SPECIALTY_DETAIL_CODE);

          if (rcpSelected[2].list.length === 1 || subSpList.length > 0) {
          state.disabledItemControl[lastSelected.length - 1] = [1];
          }
        }
    };

    const onClick = (e, contentCode, subContentCode, idx) => {
      const content = contents.value[patternContentIndex.value];

      if (!patternSelected.value[props.selectedComponentIndex])
        patternSelected.value[props.selectedComponentIndex] = [];

      // ✅ ATC 드롭다운 열려 있으면 닫기
      if (dropdownSelection.visible) {
        dropdownSelection.visible = false;
      }

      // ✅ ATC가 선택되어 있던 상태라면 초기화
      if (dropdownSelection.selectedIndex === idx) {
        dropdownSelection.selectedType = null;
        dropdownSelection.selectedIndex = null;
      }

      if (content.groupContents) {
        patternSelected.value[props.selectedComponentIndex][idx] = {
          code: contentCode, // contentCode
          list: [
            {
              ...e, //  id, name
              type: 0, // 기본
              code: subContentCode, // subContentCode
            },
          ],
        };
      } else {
        patternSelected.value[props.selectedComponentIndex][idx] = {
          code: contentCode, // contentCode
          list: [
            {
              ...e, //  id, name
              type: 0, // 기본
              code: subContentCode, // subContentCode
            },
          ],
        };
      }
      // 클릭한 아이템을 활성화된 아이템으로 설정
      state.activeItem[idx] = e;
    };

    const isActive = (data, idx) => {
      const active = state.activeItem[idx];
      if (!active) {
        return false;
      }

      if (
        props.parentMenuCode === constants.CONSTANT_MENU_CL_Diagnosis_CODE &&
        [ATC_GROUP, Molecule_GROUP].includes(data.name)
      ) {
        return (
          data.name === dropdownSelection.baseName &&
          dropdownSelection.selectedIndex === idx &&
          dropdownSelection.selectedType &&
          ((data.name === ATC_GROUP && ATC_ITEM_NAMES.includes(active.name)) ||
            (data.name === Molecule_GROUP && Molecule_ITEM_NAMES.includes(active.name)))
        );
      }

      return active.id === data.id;
    };

    const getDisplayName = (item) => {
      return locale.value === "en" && item.englishName ? item.englishName : item.name;
    };

    const openPopupImage = () => {
      // 팝업을 띄울 URL을 지정합니다.
      const popupUrl = "/ImagePopup";

      // 팝업 창의 너비와 높이를 설정합니다.
      const popupWidth = 610;
      const popupHeight = 905;

      openCenteredPopup(popupUrl, popupWidth, popupHeight);
      // 팝업을 새 창으로 엽니다.
      // window.open(
      //   popupUrl,
      //   "_blank",
      //   `width=${popupWidth}, height=${popupHeight}`
      // );
    };

    const openCenteredPopup = (url, w, h) => {
      // 화면 중앙에 위치시키기 위한 좌표 계산
      const dualScreenLeft =
        window.screenLeft !== undefined ? window.screenLeft : window.screenX;
      const dualScreenTop =
        window.screenTop !== undefined ? window.screenTop : window.screenY;

      const width = window.innerWidth
        ? window.innerWidth
        : document.documentElement.clientWidth
        ? document.documentElement.clientWidth
        : screen.width;
      const height = window.innerHeight
        ? window.innerHeight
        : document.documentElement.clientHeight
        ? document.documentElement.clientHeight
        : screen.height;

      const left = width / 2 - w / 2 + dualScreenLeft;
      const top = height / 2 - h / 2 + dualScreenTop;

      // 팝업 창 열기
      window.open(
        url,
        "_blank",
        `scrollbars=yes,resizable=no, width=${w}, height=${h}, top=${top}, left=${left}`
      );
    };

    return {
      //설정값
      constants,

      contents,
      showContent,
      patternContentIndex,
      state,
      isActive,
      onClick,
      patternSelected,
      checkedViewTotal,
      checkViewTotal,
      openPopupImage,

      dropdownSelection,
      toggleDropdown,
      selectDropdownDetail,
      getDisplayName,

      Molecule_ITEM_NAMES,
      ATC_ITEM_NAMES,
      Molecule_GROUP,
      ATC_GROUP,
    };
  },
});
</script>

<style scoped>
.condition {
  flex: 1 1 0;
  /* height: 100%;  */
  margin-left: 10px;
  transition: all 0.3s;
}

.groupContent {
  position: relative;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.group-content-header {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

.sub-content-items {
  display: flex;
  /* padding-bottom: 20px; */
  flex-wrap: wrap;
}

.sub-content-item {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 32px;
  background-color: #fff;
  border: var(--border-line);
  border-left-width: 0;
  font-size: 15px;

  cursor: pointer;
  text-align: center;
  transition: all 0.1s ease-in;
}

.sub-content-item:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-left-width: 1px;
}

.sub-content-item:nth-child(7n + 1) {
  border-bottom-left-radius: 4px;
  border-left-width: 1px;
}

.sub-content-item:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.sub-content-item:hover {
  background-color: #f5f5f5;
}

.sub-content-item:hover .material-symbols-outlined {
  font-variation-settings: "wght" 1200;
}

.sub-content-item.switchingEn {
  padding: 6px 28px;
  min-width: 200px;
}

.sub-content-item.switching {
  padding: 6px 28px;
  min-width: 130px;
}

.sub-content-item.switching:first-child {
  border-bottom-left-radius: 0px;
}

.sub-content-item.switching:nth-child(6) {
  border-top-right-radius: 4px;
}

.sub-content-item.switching:nth-child(n + 7) {
  border-top-width: 0px;
}

.sub-content-item.switching:last-child {
  border-top-right-radius: 0px;
}

.active-item,
.active-item:hover {
  border-color: var(--primary-color);
  background-color: var(--primary-color);
  color: #fff;
}

.comparison {
  margin-top: 60px;
  padding: 20px;
  background-color: #f5f5f5;
  border: 1px solid #ececec;
  border-radius: var(--border-radius);
}

.comparison h2 {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
}

.comparison h2 .material-symbols-outlined {
  font-size: 28px;
  font-variation-settings: "wght" 300;
  margin-right: 5px;
}

.comparison-container {
  display: flex;
  flex-direction: row;
  /* 가로로 정렬 */
  margin-top: 10px;
}

.comparison-item {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  /* 각 항목이 같은 비율로 공간을 차지하도록 설정 */
  padding-left: 33px;
}

.comparison-item > p {
  font-size: 15px;
  font-weight: 700;
}

.comparison-item ul li {
  position: relative;
  padding-left: 16px;
  font-size: 15px;
}

.comparison-item ul li::before {
  position: absolute;
  left: 0;
  top: 50%;
  content: "";
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #ddd;
  transform: translateY(-50%);
}

.not-active-item {
  background-color: #d5d5d5;
}

.not-active-item:hover {
  background-color: #d5d5d5;
  cursor: default;
}

.content-notice {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 700;
  padding: 10px;
  background-color: #f5f5f5;
  border: 1px solid #ececec;
  border-radius: var(--border-radius);
  margin-bottom: 10px;
}

.lock {
  display: flex;
  position: absolute;

  top: -5px;
  left: -10px;

  width: calc(100% + 10px);
  height: calc(100% + 15px);

  border-radius: 6px;
  background-color: #000000a6;

  flex-direction: column;
  justify-content: center;
  align-items: center;

  color: #fff;
  font-family: "Pretendard";
  font-size: 22px;
  font-weight: 700;
  line-height: 30px;
  text-align: center;

  z-index: 99;

  &.all {
    top: 20px;
    width: calc(100% - 315px);
    height: calc(100% - 75px);
    min-height: 625px;
  }

  > img {
    width: 40px;
    height: 40px;
    margin-bottom: 10px;
  }
}

.atcMolecule-dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 6px;
  z-index: 999;
  min-width: 140px;
  /* margin-top: 4px; */
  color: rgb(0, 0, 0);
}

.atcMolecule-dropdown-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee; /* 구분선 */
}

.atcMolecule-dropdown-item:hover {
  background-color: #d5d5d5;
  border-bottom: 1px solid #ccc; /* hover 시에도 구분선 유지 */
}

.atcMolecule-dropdown-item:last-child {
  border-bottom: none;
}

.dropdown-button {
  background: none;
  border: none;
  padding: 0;
  margin-left: 3px;
  cursor: pointer;
}

.material-symbols-outlined {
  font-size: 18px;
  vertical-align: middle;
}

.material-symbols-outlined:hover {
  font-variation-settings: "wght" 1200;
}

.notice-small {
  font-size: 15px;
}
</style>
